import { createSlice } from "@reduxjs/toolkit";
import NetworkCall from "network/networkCall";
import Request from "network/request";

export const diariesSlice = createSlice({
  name: "diaries",
  initialState: {
    //resolveit
    allDiaries: [],
    allArchiveDiaries: [],
    globalSearchResult: {},
    currentDiaryTopic: {},
    diaryStatus: {},
    diaryEntries: [],
    hasMore: false,
    hasMoreForward: false,
    entriesLoader: false,
    searchedEntriesList: [],
    fromSearch: false,
    searchEntryId: null,
    hasMoreSearchEntries: false,
    scrollLoader: false,
    scrollLoaderForward: false,
    topEntryId: null,
    currentDiaryDetail: {},
    fromNotification: false,
    globalLoaderFlag: false,
    hideClassName: "",
    totalEntryRecords: 0,
    newMessage: null,

    // Modal opener from different components
    archiveModalOpen: {
      flag: false,
      diaryId: null,
    },
    unArchiveModalOpen: {
      flag: false,
      diaryId: null,
      name: "",
    },
  },
  reducers: {
    //Resolve It
    saveAllDiaries: (state, action) => {
      state.allDiaries = [...action.payload];
    },
    saveAllArchiveDiaries: (state, action) => {
      state.allArchiveDiaries = [...action.payload];
    },
    saveGlobalSearchedData: (state, action) => {
      state.globalSearchResult = { ...action.payload };
    },
    saveNewlyCreatedDiary: (state, action) => {
      // it appends the new diary to the existing list
      state.allDiaries = [{ ...action.payload }, ...state.allDiaries];
    },
    saveNewArchivedDiary: (state, action) => {
      // it appends the new diary to the existing list
      state.allArchiveDiaries = [
        { ...action.payload },
        ...state.allArchiveDiaries,
      ];
    },
    saveDiaryStatus: (state, action) => {
      state.diaryStatus = { ...action.payload };
    },
    saveCurrentDiary: (state, action) => {
      state.currentDiaryTopic = { ...action.payload };
    },
    saveDiaryEntries: (state, action) => {
      state.diaryEntries = action.payload.append
        ? [...action.payload.data, ...state.diaryEntries]
        : [...action.payload.data];
    },
    saveDiaryEntriesForward: (state, action) => {
      state.diaryEntries = action.payload.append
        ? [...action.payload.data, ...state.diaryEntries]
        : [...state.diaryEntries, ...action.payload.data];
    },
    saveOneDiaryEntry: (state, action) => {
      state.diaryEntries = [...state.diaryEntries, { ...action.payload }];
      state.totalEntryRecords = state.totalEntryRecords + 1;
    },
    saveHasMoreEntries: (state, action) => {
      state.hasMore = action.payload;
    },
    saveHasMoreForwardEntries: (state, action) => {
      state.hasMoreForward = action.payload;
    },
    saveHasMoreSearchEntries: (state, action) => {
      state.hasMoreSearchEntries = action.payload;
    },
    saveEntriesLoader: (state, action) => {
      state.entriesLoader = action.payload;
    },
    saveScrollLoader: (state, action) => {
      state.scrollLoader = action.payload;
    },
    saveScrollLoaderForward: (state, action) => {
      state.scrollLoaderForward = action.payload;
    },

    saveSearchEntriesList: (state, action) => {
      state.searchedEntriesList = action.payload.append
        ? [...state.searchedEntriesList, ...action.payload.data]
        : [...action.payload.data];
    },
    saveFromSearchFlag: (state, action) => {
      state.fromSearch = action.payload;
    },
    saveSearchEntryId: (state, action) => {
      state.searchEntryId = action.payload;
    },

    saveCurrentDiaryDetail: (state, action) => {
      state.currentDiaryDetail = { ...action.payload };
    },
    saveFromNotificationFlag: (state, action) => {
      state.fromNotification = action.payload;
    },
    saveGlobalLoader: (state, action) => {
      state.globalLoaderFlag = action.payload;
    },
    saveHideClassName: (state, action) => {
      state.hideClassName = action.payload;
    },
    saveTotalEntryRecords: (state, action) => {
      state.totalEntryRecords = action.payload;
    },
    saveTopEntryId: (state, action) => {
      state.topEntryId = action.payload;
    },
    saveNewMessage: (state, action) => {
      state.newMessage = action.payload;
    },
    saveArchiveModalOpen: (state, action) => {
      state.archiveModalOpen = { ...action.payload };
    },
    saveUnArchiveModalOpen: (state, action) => {
      state.unArchiveModalOpen = { ...action.payload };
    },
  },
});

//ResolveIt
export const fetchAllDiaries = (flag, id) => {
  return async (dispatch, getState) => {
    try {
      // dispatch(saveEntriesLoader(true));
      const response = await NetworkCall.fetch(
        Request.getAllDiariesList(),
        flag ? false : true
      );
      const newData = response.data?.tableListing;
      dispatch(saveAllDiaries(newData));
      // dispatch(saveEntriesLoader(false));
      dispatch(saveGlobalLoader(false));
      if (id) {
        const index = newData?.findIndex((e) => e?.diaryId === id);
        dispatch(saveDiaryStatus({ diary: newData[index] }));
      }
    } catch (error) {
      dispatch(saveGlobalLoader(false));
    }
  };
};
export const fetchAllArchiveDiaries = () => {
  return async (dispatch, getState) => {
    try {
      const response = await NetworkCall.fetch(
        Request.getAllDiariesList(true),
        false
      );
      const newData = response.data?.tableListing;
      dispatch(saveAllArchiveDiaries(newData));
    } catch (error) {}
  };
};
export const fetchDiaryEntries = (payload, appendFlag) => {
  return async (dispatch, getState) => {
    try {
      appendFlag && dispatch(saveScrollLoader(true));
      const response = await NetworkCall.fetch(
        Request.getDiariesEntries(payload),
        false
      );
      //.slice(0).reverse()
      if (response?.data?.data) {
        dispatch(saveTotalEntryRecords(response?.data?.totalRecords));

        dispatch(
          saveDiaryEntries({
            data: response?.data?.data.slice(0).reverse(),
            append: appendFlag,
          })
        );
        const index = response?.data?.data?.findIndex(
          (e) => e.releasedEntryId === payload?.releasedEntryId
        );

        if (payload.direction === 3) {
          dispatch(
            saveHasMoreEntries(
              // false
              response?.data?.data.length >= 10 ? true : false
            )
          );
          dispatch(
            saveHasMoreForwardEntries(
              response?.data?.data.length >= 10 ? true : false
            )
          );
        } else {
          dispatch(
            saveHasMoreEntries(
              response?.data?.data.length === 10 ? true : false
            )
          );
        }
      } else {
        !appendFlag && dispatch(saveTotalEntryRecords(0));

        dispatch(saveHasMoreEntries(false));
      }
      dispatch(saveEntriesLoader(false));
      dispatch(saveScrollLoader(false));
    } catch (error) {
      dispatch(saveEntriesLoader(false));
    }
  };
};
export const fetchDiaryEntriesForward = (payload) => {
  return async (dispatch, getState) => {
    try {
      const response = await NetworkCall.fetch(
        Request.getDiariesEntries(payload),
        false
      );
      //.slice(0).reverse()
      if (response?.data?.data) {
        dispatch(saveTotalEntryRecords(response?.data?.totalRecords));
        dispatch(
          saveTopEntryId(
            response?.data?.data[response?.data?.data.length - 1]?.diaryEntryId
          )
        );

        dispatch(
          saveDiaryEntriesForward({
            data: response?.data?.data.slice(0).reverse(),
            append: false,
          })
        );
        dispatch(
          saveHasMoreForwardEntries(
            response?.data?.data.length === 10 ? true : false
          )
        );
      } else {
        // dispatch(saveDiaryEntries({ data: [], append: appendFlag }));
        dispatch(saveHasMoreForwardEntries(false));
      }
      dispatch(saveScrollLoaderForward(false));
    } catch (error) {
      dispatch(saveScrollLoaderForward(false));
    }
  };
};

export const fetchSearchList = (payload, append) => {
  return async (dispatch, getState) => {
    try {
      const response = await NetworkCall.fetch(
        Request.getDiariesEntries(payload),
        false
      );
      if (response?.data?.data) {
        dispatch(
          saveSearchEntriesList({ data: response?.data?.data, append: append })
        );
        dispatch(
          saveHasMoreSearchEntries(
            response?.data?.data.length === 15 ? true : false
          )
        );
      } else {
        dispatch(saveSearchEntriesList({ data: [], append: append }));
        saveHasMoreSearchEntries(false);
      }
      dispatch(saveEntriesLoader(false));
      dispatch(saveScrollLoaderForward(false));
      //.slice(0).reverse()
    } catch (error) {
      saveHasMoreSearchEntries(false);
      dispatch(saveEntriesLoader(false));

      dispatch(saveScrollLoaderForward(false));
    }
  };
};

export const getDiaryStatus = (data) => {
  return async (dispatch, getState) => {
    try {
      const response = await NetworkCall.fetch(Request.getDiary(data), false);
      const newData = response?.data;
      dispatch(saveCurrentDiaryDetail(newData));
    } catch (error) {}
  };
};

export const {
  //Resolve-it
  saveSearchComp,
  saveAllDiaries,
  saveAllArchiveDiaries,
  saveDiaryStatus,
  saveDiaryEntries,
  saveHasMoreEntries,
  saveNewlyCreatedDiary,
  saveEntriesLoader,
  saveOneDiaryEntry,
  saveSearchEntriesList,
  saveFromSearchFlag,
  saveSearchEntryId,
  saveScrollLoader,
  saveCurrentDiaryDetail,
  saveFromNotificationFlag,
  saveGlobalLoader,
  saveHideClassName,
  saveTotalEntryRecords,
  saveDiaryEntriesForward,
  saveHasMoreForwardEntries,
  saveScrollLoaderForward,
  saveHasMoreSearchEntries,
  saveGlobalSearchedData,
  saveCurrentDiary,
  saveTopEntryId,
  saveNewMessage,
  saveNewArchivedDiary,
  saveArchiveModalOpen,
  saveUnArchiveModalOpen,
} = diariesSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
// Resolve-It
export const allDiaries = (state) => state.diaries.allDiaries;
export const arciveDiaries = (state) => state.diaries.allArchiveDiaries;
export const archiveModalOpen = (state) => state.diaries.archiveModalOpen;
export const unArchiveModalOpen = (state) => state.diaries.unArchiveModalOpen;
export const diaryStatus = (state) => state.diaries.diaryStatus;
export const currentDiaryTopic = (state) => state.diaries.currentDiaryTopic;
export const diaryEntries = (state) => state.diaries.diaryEntries;
export const hasMore = (state) => state.diaries.hasMore;
export const hasMoreForward = (state) => state.diaries.hasMoreForward;
export const hasMoreSearch = (state) => state.diaries.hasMoreSearchEntries;
export const entriesLoader = (state) => state.diaries.entriesLoader;
export const searchedEntriesList = (state) => state.diaries.searchedEntriesList;
export const searchedFlag = (state) => state.diaries.fromSearch;
export const searhcedId = (state) => state.diaries.searchEntryId;
export const scrollLoader = (state) => state.diaries.scrollLoader;
export const scrollLoaderForward = (state) => state.diaries.scrollLoaderForward;
export const currentDiaryDetail = (state) => state.diaries.currentDiaryDetail;
export const notificationFlag = (state) => state.diaries.fromNotification;
export const globalLoaderFlag = (state) => state.diaries.globalLoaderFlag;
export const hideClassName = (state) => state.diaries.hideClassName;
export const totalRecord = (state) => state.diaries.totalEntryRecords;
export const globalSearchData = (state) => state.diaries.globalSearchResult;
export const currentDiary = (state) => state.diaries.currentDiaryTopic;
export const topEntryId = (state) => state.diaries.topEntryId;
export const newMessage = (state) => state.diaries.newMessage;

export default diariesSlice.reducer;
